import React, {forwardRef} from 'react'
import classnames from 'classnames'

// @ts-ignore
import styles from './InputWithText.scss'

export type InputWithTextProps = JSX.IntrinsicElements['input'] & {
  text: string
  isError?: boolean
}

export const InputWithText = forwardRef<HTMLInputElement, InputWithTextProps>(
  ({type = 'text', isError = false, disabled, className, text, ...props}, ref) => {
    const containerStyle = classnames(
      styles.inputWithTextContainer,
      {[styles.invalid]: isError},
      {[styles.disabled]: disabled},
      className
    )

    const inputStyle = classnames(
      styles.inputWithText,
      {[styles.disabled]: disabled}
    )

    const textStyle = classnames(
      styles.text,
      {[styles.disabled]: disabled}
    )

    return (
      <div className={containerStyle}>
        <input
          {...props}
          ref={ref}
          type={type}
          className={inputStyle}
          disabled={disabled}
        />
        <span className={textStyle}>
          {text}
        </span>
      </div>
    )
  }
)
